if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
        this.desktopMedia = null;
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;
        this.tabButtons = this.querySelectorAll('.collapsible-tabs__tab');
        this.accordionItems = this.querySelectorAll('.accordion-item[data-tab-index]');

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });

        this.desktopMedia = window.matchMedia('(min-width: 768px)');
        this.desktopMedia.addEventListener('change', this.onDesktopChange.bind(this));
        if (this.desktopMedia.matches) {
          this.initDesktopTabs();
        }
      }

      disconnectedCallback() {
        this.desktopMedia?.removeEventListener('change', this.onDesktopChange?.bind(this));
        this.tabButtons?.forEach((btn) => {
          btn.removeEventListener('click', this.onTabClick);
        });
      }

      onDesktopChange(e) {
        if (e.matches) this.initDesktopTabs();
      }

      initDesktopTabs() {
        if (!this.tabButtons?.length || !this.accordionItems?.length) return;
        const openDetails = Array.from(this.detailsElements).find((d) => d.open);
        const openItem = openDetails?.closest('.accordion-item');
        const activeIndex = openItem?.dataset?.tabIndex ?? '0';
        this.setActiveTab(activeIndex);
        this.tabButtons.forEach((btn) => {
          btn.removeEventListener('click', this.onTabClick);
          btn.addEventListener('click', this.onTabClick = (e) => {
            const idx = e.currentTarget.dataset.tabIndex;
            this.setActiveTab(idx);
          });
        });
      }

      setActiveTab(tabIndex) {
        this.tabButtons?.forEach((btn) => {
          btn.setAttribute('aria-selected', btn.dataset.tabIndex === String(tabIndex));
        });
        this.accordionItems?.forEach((item) => {
          const details = item.querySelector('.accordion-details');
          if (details && item.dataset.tabIndex === String(tabIndex)) {
            details.open = true;
            this.handleOpen(details);
          } else if (details) {
            details.open = false;
            this.handleClose(details);
          }
        });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
        /* 仅在 details 被“打开”时同步 tab，避免关闭其它项时触发的 toggle 把选中 tab 又切回去 */
        if (this.desktopMedia?.matches && this.tabButtons?.length && activeDetails.open) {
          const item = activeDetails.closest('.accordion-item');
          const idx = item?.dataset?.tabIndex;
          if (idx != null) this.setActiveTab(idx);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent?.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent?.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
